import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, MapPin, Clock } from 'lucide-react';

const EventCard = ({ event, onRegister }) => {
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const eventDate = new Date(event.date);
            const diff = eventDate - now;

            if (diff <= 0) {
                setTimeLeft('Event started');
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

            setTimeLeft(`Starts in: ${days} Days ${hours} Hours ${minutes} Minutes`);
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);
        return () => clearInterval(timer);
    }, [event.date]);

    return (
        <div className="group relative bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
            {/* Event Image */}
            <div className="relative h-48 overflow-hidden">
                <img
                    src={event.image || 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800'}
                    alt={event.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                    <span className="bg-purple-600 text-white text-[10px] font-bold px-2 py-1 rounded-md uppercase tracking-wider mb-2 inline-block">
                        {event.club?.name || 'Club Event'}
                    </span>
                    <h3 className="text-xl font-bold text-white leading-tight line-clamp-1">{event.name}</h3>
                </div>
            </div>

            {/* Content */}
            <div className="p-6">
                <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3 text-gray-600">
                        <Calendar className="w-4 h-4 text-purple-500" />
                        <span className="text-sm font-medium">{new Date(event.date).toLocaleDateString(undefined, { dateStyle: 'long' })}</span>
                    </div>
                    <div className="flex items-center gap-3 text-gray-600">
                        <MapPin className="w-4 h-4 text-purple-500" />
                        <span className="text-sm font-medium line-clamp-1">{event.venue}</span>
                    </div>
                    <div className="flex items-center gap-3 py-2 px-3 bg-purple-50 rounded-xl border border-purple-100/50">
                        <Clock className="w-4 h-4 text-purple-600" />
                        <span className="text-xs font-bold text-purple-700 font-mono tracking-tight animate-pulse">
                            {timeLeft}
                        </span>
                    </div>
                </div>

                <button
                    onClick={() => navigate(`/event/${event._id}`)}
                    className="w-full py-3.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-2xl text-sm font-bold hover:shadow-lg hover:shadow-purple-200 transition-all active:scale-[0.98]"
                >
                    Register for Event
                </button>
            </div>
        </div>
    );
};

export default EventCard;
